import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/react/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Recursive\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-recursive\"}],\"variableName\":\"recursive\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ActiveLink"] */ "/vercel/path0/src/components/ActiveLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/design-system/global.css");
